import { useCallback } from "react";
import { useMutation } from "@apollo/client";

import {
  ClientProfileDocument,
  UpdateAccountPhoneNumberDocument,
} from "../../__generated__/graphql";

export function useUpdateAccountPhoneNumber() {
  const [mutate, state] = useMutation(UpdateAccountPhoneNumberDocument, {
    refetchQueries: [ClientProfileDocument],
    awaitRefetchQueries: true,
  });

  const updateAccountPhoneNumber = useCallback(
    async (clientId: string, phoneNumber: string) => {
      const { data } = await mutate({ variables: { input: { clientId, phoneNumber } } });
      return Boolean(data?.updateAccountPhoneNumber?.success);
    },
    [mutate],
  );

  return [updateAccountPhoneNumber, state] as const;
}
